// extracted by mini-css-extract-plugin
export var pool = "style-module--pool--1Qko6";
export var poolTicker = "style-module--poolTicker--2THXI";
export var pulse = "style-module--pulse--3relT";
export var poolItem = "style-module--poolItem--3hBFi";
export var poolLabel = "style-module--poolLabel--37xKU";
export var poolValue = "style-module--poolValue--gp8Rm";